import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import { SkillEntity } from '@core/tellent-skills-types';
import { ORG_GUID } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class SkillsHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);
  private readonly orgGuid = inject(ORG_GUID)!;

  public fetchAvailableSkills(): Observable<SkillEntity> {
    return this.httpApi
      .get(`/positions/org/${this.orgGuid}/skills`, null, { skipCompany: true })
      .pipe(take(1));
  }
}
